class GetPaymentBoletoError extends Error {
  constructor(cause, url, props, code = 'GET_PAYMENT_BOLETO_ERROR') {
    super("Falha ao gerar pagamento por boleto");
    this.name = 'GetPaymentBoletoError';
    this.code = code;
    this.cause = cause;
    this.url = url;
    this.props = props;

    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, GetPaymentBoletoError);
    }
  }
}

module.exports = GetPaymentBoletoError;